var LOADABLE_MARKS = new Map();
export var createLoadableStream = function () { return ({ marks: {} }); };
var clearStream = function (stream) {
    if (stream) {
        stream.marks = {};
    }
};
var checkStream = function (stream) {
    if (process.env.NODE_ENV !== 'production') {
        if (!stream) {
            return;
        }
        if (typeof stream !== 'object' || !stream.marks) {
            throw new Error('react-imported-component: version 6 requires `stream` to be an object. Refer to the migration guide');
        }
    }
};
export var defaultStream = createLoadableStream();
export var useMark = function (stream, marks) {
    if (stream === void 0) { stream = defaultStream; }
    checkStream(stream);
    if (marks && marks.length) {
        marks.forEach(function (a) { return stream.marks[a] = true; });
    }
};
export var assingLoadableMark = function (mark, loadable) {
    LOADABLE_MARKS.set(JSON.stringify(mark), { mark: mark, loadable: loadable });
};
export var getUsedMarks = function (stream) {
    if (stream === void 0) { stream = defaultStream; }
    return (stream
        ? Object.keys(stream.marks)
        : []);
};
export var drainHydrateMarks = function (stream) {
    if (stream === void 0) { stream = defaultStream; }
    checkStream(stream);
    var marks = getUsedMarks(stream);
    clearStream(stream);
    return marks;
};
export var markerOverlap = function (a1, a2) { return a1.filter(function (mark) { return a2.indexOf(mark) >= 0; }).length === a1.length; };
export var rehydrateMarks = function (marks) {
    var rehydratedMarks = marks || global.___REACT_DEFERRED_COMPONENT_MARKS || [];
    var tasks = [];
    var usedMarks = new Set();
    LOADABLE_MARKS
        .forEach(function (_a) {
        var mark = _a.mark, loadable = _a.loadable;
        if (markerOverlap(mark, rehydratedMarks)) {
            mark.forEach(function (m) { return usedMarks.add(m); });
            tasks.push(loadable.load());
        }
    });
    rehydratedMarks.forEach(function (m) {
        if (!usedMarks.has(m)) {
            throw new Error("react-imported-component: unknown mark(" + m + ") has been used. Client and Server should have the same babel configuration.");
        }
    });
    return Promise.all(tasks);
};
export var waitForMarks = function (marks) {
    var tasks = [];
    LOADABLE_MARKS
        .forEach(function (_a) {
        var mark = _a.mark, loadable = _a.loadable;
        if (markerOverlap(mark, marks)) {
            tasks.push(loadable.resolution);
        }
    });
    return Promise.all(tasks);
};
export var printDrainHydrateMarks = function (stream) {
    checkStream(stream);
    return "<script>window.___REACT_DEFERRED_COMPONENT_MARKS=" + JSON.stringify(drainHydrateMarks(stream)) + ";</script>";
};
